import { processClinicData } from '../clinic'
import i18next from "i18next";
import {translation} from "../../actions/emergency"
import { careOptions, commonConstant } from "../../../../server/triage/constants";
import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../../features/utils";

export async function getTriageServiceLocations({ state, setState ,actions }) {

  const { triageRequest } = state
  const {

    selectedCareOptionName,
    selectedCareOptionScore,

    // See: triage/actions/location
    locationMeta: {
      address, zip, //state: addressState, // API doesn't accept these
      ...locationMeta
    },

    sessionId, ageInYears, ageInDays,

  } = triageRequest
  

  //if (!selectedCareOptionScore || !selectedCareOptionName) return false
  console.log('Pase!')
  var service1 = "";
  var service2 = "";
  if(selectedCareOptionName == careOptions.MedicalFacility)
  {
    service1 = careOptions.EmergencyRoom;
    service2 = careOptions.UrgentCare;
  }
  else{
    service1 = localStorage.getItem('careoption');
  }
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
  localStorage.setItem("Identifier",sessionId)
  const data = {
   identifier:sessionId,
   Token:localStorage.getItem('token'),

    score: selectedCareOptionScore, // From getScoreFromAnswers
    service1, // From getServiceCategoriesByScore
    service2,
    time: (new Date()).toISOString(),
    radius: 100,
    unit: 'km',

    ...locationMeta,

    age: ageInYears,
    ageDays: ageInDays,
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
   
  }
  console.log('state')
  console.log(state)
  console.log('*******************************************************************')

  console.log('data')
  console.log(data)


  console.log('antes de llamar a getServiceLocations')
  const success = await actions.sendTriageRequest({   
      action: 'getServiceLocations',
      data   
  })

  if (success && success.message === commonConstant.success) {
    setState({
      msg: ""
    })
    actions.generateSessionResults()
  }

}

export function generateSessionResults({ state,setState, actions }) {

  const { triageResponse: { serviceLocations = [] } } = state

  const markers = []
  const clinics = []
  if (typeof serviceLocations === 'string') {
    setState({
      msg: serviceLocations,
     
    })
  }
  else{
  serviceLocations.forEach( m => {
    console.log(m)

    markers.push({
      lat: m.latitude,
      lng: m.longitude,
    })

      const processedData = processClinicData(m);
     let processedDataResult=translation(processedData)
    clinics.push(processedDataResult)

  })

  }
 
  actions.setTriageResponse({
    sessionResults: { markers, clinics }
  })
}
